// src/components/works/EducationContent.tsx
import React from 'react';
import {
  IntroText,
  SubHeading,
  ContentParagraph,
  EmphasisText,
  StyledList,
  StyledListItem,
  CallToActionText,
} from '../../styles/GlobalStyles';

const EducationContent: React.FC = () => {
  return (
    <>
      <IntroText>
        変化の時代を勝ち抜く、実践的ITスキルとDXマインドを育成します。
      </IntroText>
      <ContentParagraph>
        課題: 社員のITリテラシー向上、DX人材不足、最新技術トレンドの活用方法...
      </ContentParagraph>
      <ContentParagraph>
        Ludyworksの教育事業は、実践的な演習で即戦力となるスキルと知識を習得。
        企業様の課題に寄り添い、オーダーメイド研修で成長を支援します。
      </ContentParagraph>

      <SubHeading>提供プログラム</SubHeading>
      <StyledList>
        <StyledListItem>
          <EmphasisText>DX人材育成：</EmphasisText>
          DX基礎、リーダー養成、データ活用、デザイン思考
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>ITエンジニア育成：</EmphasisText>
          プログラミング、Webアプリ開発、クラウド技術、アジャイル開発
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>デジタルマーケティング：</EmphasisText>
          SEO/MEO、Web広告、コンテンツマーケティング、GA4活用
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>最新技術セミナー：</EmphasisText>
          AI、IoT、ブロックチェーン、ノーコード/ローコード
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>情報セキュリティ：</EmphasisText>
          セキュリティ基礎、テレワーク対策、ITパスポート
        </StyledListItem>
      </StyledList>

      <SubHeading>研修・セミナーの特徴</SubHeading>
      <StyledList>
        <StyledListItem>
          <EmphasisText>実践重視：</EmphasisText>
          演習、グループワーク、ケーススタディで「できる」へ
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>柔軟なカスタマイズ：</EmphasisText>
          業種、職種、スキルに合わせ内容をカスタマイズ
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>プロ講師陣：</EmphasisText>
          専門知識と実務経験豊富な講師
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>継続的支援：</EmphasisText>
          研修後のフォローアップ、効果測定
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>多様な形式：</EmphasisText>
          対面、オンライン、ハイブリッド
        </StyledListItem>
      </StyledList>

      <SubHeading>こんな企業に最適</SubHeading>
      <ContentParagraph>
        - ITリテラシー向上とデジタル化意識改革を目指す企業
        - DX戦略を推進する人材を育成したい企業
        - エンジニアチームの技術力向上を支援したい企業
        - 最新デジタルトレンドをビジネスに活かしたい企業
      </ContentParagraph>

      <CallToActionText>
        未来を担う人材育成をサポート。研修内容や費用はお気軽にお問い合わせください。
      </CallToActionText>
    </>
  );
};

export default EducationContent;
